"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = template;

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("../style/index"));

var _createStyled = require("../../../utils/createStyled");

var _renderprops = require("react-spring/renderprops");

var Hint = (0, _renderprops.animated)(_createStyled.Styled.Div);

function template() {
  var _this = this;

  var styles = this.compileStyled(_index["default"]),
      _this$props = this.props,
      labelClassName = _this$props.labelClassName,
      label = _this$props.label,
      children = _this$props.children,
      hidden = this.state.hidden;
  return _react["default"].createElement(_createStyled.Styled.Div, {
    onMouseLeave: this._handleMouseLeave,
    ref: this.rootEl,
    styles: styles.root
  }, _react["default"].createElement(_renderprops.Transition, {
    items: hidden,
    from: {
      opacity: 0
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    },
    "native": true,
    config: _renderprops.config.stiff
  }, function (hidden) {
    return !hidden && function (props) {
      return _react["default"].createElement(Hint, {
        styles: styles.wrapper,
        ref: _this.hintEl,
        style: props
      }, _react["default"].createElement(_createStyled.Styled.Div, {
        styles: styles.label,
        className: labelClassName
      }, label), _react["default"].createElement(_createStyled.Styled.Div, {
        styles: styles.triangle
      }));
    };
  }), _react["default"].createElement("div", {
    onMouseEnter: this._handleMouseEnter
  }, children));
}